import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';

const AgeGroupButton = (_param)=> {
    var { text , isSelected =false , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "text",
        "isSelected",
        "className"
    ]);
    return React.createElement("button", swcHelpers.extends({}, rest, {
        className: classnames('appointments-age-group-button', className, {
            isSelected
        })
    }), text ? /*#__PURE__*/ React.createElement(Text, {
        className: "button__text",
        variant: "caption-head"
    }, text) : null);
};
var AgeGroupButton$1 = AgeGroupButton;

export { AgeGroupButton$1 as default };
//# sourceMappingURL=AgeGroupButton.js.map
